import api from "@/lib/api";
import type {
  AccountInfoPayload,
  ChangePasswordPayload,
  DeleteAccountPayload,
} from "../types";

const SETTINGS_ENDPOINTS = {
  UPDATE_ACCOUNT: (id: string) => `/users/${id}/`,
  CHANGE_PASSWORD: "/users/change_password/",
  DELETE_ACCOUNT: (id: string) => `/users/${id}/delete-account/`,
};

export class SettingsHttpRepository {
  async updateAccountInfo(
    id: string,
    payload: AccountInfoPayload,
  ): Promise<void> {
    await api.patch(SETTINGS_ENDPOINTS.UPDATE_ACCOUNT(id), payload);
  }

  async changePassword(payload: ChangePasswordPayload): Promise<void> {
    await api.post(SETTINGS_ENDPOINTS.CHANGE_PASSWORD, payload);
  }

  async deleteAccount(
    id: string,
    payload: DeleteAccountPayload,
  ): Promise<void> {
    await api.post(SETTINGS_ENDPOINTS.DELETE_ACCOUNT(id), payload);
  }
}
